function YoutubeIcon({ size = 48 }) {
  return (
    <svg width={size} height={size} viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.75' y='0.75' width='46.5' height='46.5' rx='23.25' fill='white' />
      <rect x='0.75' y='0.75' width='46.5' height='46.5' rx='23.25' stroke='#EAECF0' strokeWidth='1.5' />
      <g transform='translate(5 5)'>
        <path
          d='M27.4375 14.9141C27.2422 14.1914 26.6719 13.6211 25.9492 13.4258C24.6406 13.0703 19 13.0703 19 13.0703C19 13.0703 13.3398 13.0703 12.0508 13.4258C11.3281 13.6211 10.7578 14.1914 10.5625 14.9141C10.207 16.2227 10.207 19 10.207 19C10.207 19 10.207 21.7969 10.5625 23.0859C10.7578 23.8086 11.3281 24.3789 12.0508 24.5742C13.3594 24.9297 19 24.9297 19 24.9297C19 24.9297 24.6406 24.9297 25.9492 24.5742C26.6719 24.3789 27.2422 23.8086 27.4375 23.0859C27.793 21.7969 27.793 19 27.793 19C27.793 19 27.793 16.2227 27.4375 14.9141Z'
          fill='black'
        />
        <path d='M17.0859 22.25L21.7812 19L17.0859 15.75V22.25Z' fill='white' />
      </g>
    </svg>
  )
}

export default YoutubeIcon